<template>
  <div v-if="this.content.contentObject">
    <b-container fluid class="content-max-width">
      <div class="d-flex d-flex-row flex-wrap">
        <h5 class="d-flex d-flex-row">
          <div
            class="d-flex d-flex-row"
            v-if="
              !checkPath(['content', 'gazprom-classes', 'gazprom-universities']) && !isCurrentClassPage
            "
          >
            <router-link to="../">
              Лента новостей
            </router-link>
            <div class="mx-2">
              /
            </div>
          </div>
          <b-link
            v-if="checkPath('history_of_content')"
            to=".."
            @click="backToContentList"
            >История изменений конента</b-link
          >
          <b-link
            v-else-if="
              !checkPath(['gazprom-classes', 'gazprom-universities']) &&
                !this.$route.params.type && !isCurrentClassPage
            "
            to="./"
          >
            {{ titlePrefix }}
          </b-link>
          <b-link v-else-if="this.$route.params.type" to="..">
            {{ titleForVerificationSpecialist }}
          </b-link>
          <div v-else-if="!isCurrentClassPage">
            <b-link  to="../../main">
              Главная страница
            </b-link>
            <div class="d-inline mx-2">
              /
            </div>
          </div>
        </h5>
        <b-button
          v-b-modal.membersModal
          variant="outline-primary"
          class="ml-auto"
          v-if="isWithMembers"
          >Участники</b-button
        >
      </div>
      <b-row class="mb-3"
             v-if="isClassOpenedByTeacher">
        <b-btn variant="outline-primary"
               class="addButton ml-3"
               @click="addEvent"
        >
          <em class="fas fa-plus send-icon mr-1"></em> Добавить новое мероприятие
        </b-btn>
      </b-row>
      <h2 class="d-flex d-flex-row">
        {{ title }}
      </h2>
      <b-img
        fluid
        :src="avatar"
        @error="$event.target.src = defaultImage"
        alt="avatar"
        @click="
          showPhotoModal({
            source: avatar,
            id: content.contentObject.avatar,
          })
        "
        class="mb-3 w-100"
      />
      <p
        v-show="content.contentObject.shortDescription !== emptyText"
        class="lead text-justify"
        v-html="content.contentObject.shortDescription"
      />
      <p
        v-html="content.contentObject.fullDescription"
        class="text-justify"
      />
      <div
        v-if="content.contentObject.status === 'опубликовано'"
        class="contentFooter w-100 d-inline-flex justify-content-end"
      >
        <div v-if="isLikable" class="rating d-inline-flex justify-content-between">
          <div @click="onLike" class="rating__button rating__button-like mr-2">
            <icon-base
              class="icon mr-1"
              :class="isLiked ? 'icon-pressed' : ''"
              :icon-name="'like'"
              :viewBox="'0 0 478.2 478.2'"
            >
              <icon-like />
            </icon-base>
            <span class="num">
              {{ likes }}
            </span>
          </div>
          <div @click="onDislike" class="rating__button rating__button-dislike">
            <icon-base
              class="icon mr-1"
              :class="isDisliked ? 'icon-pressed' : ''"
              :icon-name="'dislike'"
              :viewBox="'0 0 478.2 478.2'"
            >
              <icon-dislike />
            </icon-base>
            <span class="num">
              {{ dislikes }}
            </span>
          </div>
        </div>
      </div>

      <!-- Карусель с фото -->
      <div
        v-if="
          carouselPhotos.length > 0 && content.contentObject.type !== 'Курс'
        "
      >
        <h4>Фото</h4>
        <b-carousel
          :interval="4000"
          controls
          indicators
          background="#e4dede"
        >
          <b-carousel-slide
            v-for="(photo, index) in carouselPhotos"
            class="photo-carousel-container"
            :key="index"
          >
            <template #img>
              <div class="d-flex text-center h-100">
                <img
                  :src="photo.source"
                  :class="isImageHorizontal(photo.source) ? 'w-100' : 'h-100'"
                  class="my-auto mx-auto"
                  @error="$event.target.src = defaultImage"
                />
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>

      <!-- Карусель с видео -->
      <div v-if="videos && videos.length > 0">
        <h4>Видео</h4>
        <carousel class="mt-3 carousel-container" :perPageCustom="[[0, 1], [768, 2]]">
          <slide
            v-for="(video, index) in videos"
            :key="index"
            @slideclick="showVideoModal(video.source)"
          >
            <b-img
              width="300"
              :src="video.preview"
              @error="$event.target.src = defaultImage"
              class="carouselPhoto"
            />
          </slide>
        </carousel>
      </div>
      <div v-if="votingParticipation && withVoting">
        <VotingParticipation />
      </div>
      <div v-if="withVoting">
        <Voting />
      </div>
    </b-container>

    <!-- Модальное окно показа фото -->
    <b-modal size="xl" ref="photoModal" id="photoModal">
      <img
        class="mx-auto"
        :width="imageWidth"
        :src="photoForOpen"
        style="display: block"
      />
      <template v-slot:modal-footer="{}">
        <div class="text-center w-100">
          <b-button-group>
            <b-button
              @click="gotoPhoto(-1)"
              variant="primary"
              :disabled="
                (photoForOpenObject &&
                  photoForOpenObject.id === content.contentObject.avatar) ||
                  carouselPhotos.length < 2
              "
            >
              <em class="fas fa-angle-left"></em>
            </b-button>
            <b-button
              @click="gotoPhoto(1)"
              variant="primary"
              :disabled="
                (photoForOpenObject &&
                  photoForOpenObject.id === content.contentObject.avatar) ||
                  carouselPhotos.length < 2
              "
            >
              <em class="fas fa-angle-right"></em>
            </b-button>
          </b-button-group>
        </div>
      </template>
    </b-modal>
    <!-- Модальное окно показа видео -->
    <b-modal size="xl" ref="videoModal" hide-footer id="videoModal">
      <iframe
        width="100%"
        :src="videoForOpen"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        :height="iframeHeight"
      >
      </iframe>
    </b-modal>
    <b-modal
      size="lg"
      ref="membersModal"
      id="membersModal"
      hide-footer
      :title="memberModalTitle"
    >
      <v-modal-event-members
        :title="content.contentObject.title"
        @closeEventModal="closeEventMembersModal"
      ></v-modal-event-members>
    </b-modal>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'

import IconBase from '@/components/content/likes/IconBase.vue'
import IconLike from '@/components/content/likes/IconLike.vue'
import IconDislike from '@/components/content/likes/IconDislike.vue'

import ContentAPI from '@/api/content'

import { emptyShortDescription } from '@/config/config'
import VotingParticipation from '@/components/content/events/voting/Participation.vue'
import Voting from '@/components/content/events/voting/choice/index.vue'

/* eslint-disable no-plusplus */
/* eslint-disable prefer-template */

const VModalEventMembers = () => import('@/components/content/events/ModalEventMembers.vue')

export default {
  name: 'ContentInfo',
  components: {
    Carousel,
    Slide,
    VModalEventMembers,
    IconBase,
    IconLike,
    IconDislike,
    VotingParticipation,
    Voting
  },
  props: {
    withVoting: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      photoForOpenObject: null,
      photoForOpen: null,
      imageWidth: null,
      videoForOpen: null,
      iframeHeight: null,
      defaultImage: '/images/w1400_1.jpg',
      avatarClass: null,
      emptyText: emptyShortDescription,
      windowWidth: 0,
      contentWidth: 0,
      votingParticipation: null
    }
  },
  updated() {
    if (this.content.contentObject) {
      this.onCheckRouteType()
      this.replaceYoutubeOembed()
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth
    if (this.content.contentObject) {
      this.onCheckRouteType()
      this.votingParticipation = this.content.contentObject.votingSettings
        ? _.cloneDeep(this.content.contentObject.votingSettings.participant)
        : null
      this.replaceYoutubeOembed()
    }
    window.onresize = () => {
      this.checkPhotoSize(document.documentElement)
    }
    window.addEventListener('keyup', (event) => {
      if (
        this.photoForOpen !== null
        && this.$refs.photoModal
        && !this.$refs.photoModal.isHidden
      ) {
        if (event.key === 'ArrowRight') {
          this.gotoPhoto(1)
        } else if (event.key === 'ArrowLeft') {
          this.gotoPhoto(-1)
        }
      }
    })
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    this.setContentData({})
  },
  watch: {
    content: {
      handler() {
        if (this.content.contentObject) {
          this.votingParticipation = this.content.contentObject.votingSettings
            ? _.cloneDeep(this.content.contentObject.votingSettings.participant)
            : null
        }
      },
      deep: true
    }
  },
  computed: {
    // Вычисление количества отображаемых картинок на одной странице фото карусели
    // в зависимости от размеров экрана
    /* carouselShowPhotos() {
      const defaultVal = [[0, 1], [720, 2]]
      for (let i = 3; i <= this.images.length; i++) {
        defaultVal.push([300 * i + 20 + 100 * i, i])
      }
      return defaultVal
    }, */
    carouselPhotos() {
      return this.images
        ? this.images.filter(
          (image) => image.id !== this.content.contentObject.avatar,
        )
        : []
    },
    // Вычисление количества отображаемых картинок на одной странице видео карусели
    // в зависимости от размеров экрана
    /* carouselShowVideos() {
      const defaultVal = [[0, 1], [720, 2]]
      for (let i = 3; i <= this.videos.length; i++) {
        defaultVal.push([300 * i + 20 + 100 * i, i])
      }
      return defaultVal
    }, */
    ...mapGetters({
      content: 'content/getContent',
      lastEvents: 'content/getEvents',
      titlePrefix: 'content/getTitlePrefix',
      // Получение типа контента, отображаемого на странице
      // (новости, мероприятия, газпром-классы, вузы-партнеры)
      contentType: 'content/getContentType',
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser'
    }),
    title() {
      let str = ''
      if (this.contentType === 'news') {
        str += new Date(this.content.contentObject.createdAt).toLocaleDateString() + '. '
      } else if (this.contentType === 'event') {
        str += new Date(this.content.contentObject.scheduleDate).toLocaleDateString() + '. '
      }
      return str + (this.content.contentObject.title ? this.content.contentObject.title : 'Название отсутствует')
    },
    titleForVerificationSpecialist() {
      if (this.$route.params.type === 'await') {
        return 'Ожидают рассмотрения'
      }
      if (this.$route.params.type === 'accepted') {
        return 'Подтверждено'
      }
      if (this.$route.params.type === 'rejected') {
        return 'Отклонено'
      }
      if (this.$route.params.type === 'removed') {
        return 'Снято с публикации'
      }
      return ''
    },
    avatar() {
      let avatar = this.defaultImage
      if (
        this.content.contentObject
        && this.content.contentObject.avatar
        && this.content.contentObject.files
      ) {
        avatar = `/api/files/${
          this.content.contentObject.files.find(
            (p) => p.id === this.content.contentObject.avatar,
          ).physicalName
        }`
        this.imgClass(avatar)
      }
      return avatar
    },
    likes() {
      if (this.content.contentObject && this.content.contentObject.type === 'Мероприятие') {
        return this.content.contentObject.likes
      }
      return 0
    },
    dislikes() {
      if (this.content.contentObject && this.content.contentObject.type === 'Мероприятие') {
        return this.content.contentObject.dislikes
      }
      return 0
    },
    /* avatarClassLoaded() {
      return this.content.contentObject.type === 'ВУЗ-партнер'
        ? this.avatarClass
        : ''
    },
    imgWrappCol() {
      let colClass = 'col image-col'
      if (this.content.contentObject.shortDescription) {
        if (this.avatarClassLoaded === 'imgVCWrapper') {
          colClass = 'col-3 image-col'
        }
      }

      return colClass
    }, */
    images() {
      const imagePaths = []
      if (this.content.contentObject && this.content.contentObject.files) {
        const images = this.content.contentObject.files.filter(
          (p) => p.type === 'img',
        )
        if (images) {
          for (let i = 0; i < images.length; i++) {
            imagePaths.push({
              source: `/api/files/${images[i].physicalName}`,
              id: images[i].id
            })
          }
        }
      }
      return imagePaths
    },
    videos() {
      const videoPaths = []
      if (this.content.contentObject && this.content.contentObject.files) {
        const videos = this.content.contentObject.files.filter(
          (p) => p.type === 'video',
        )
        if (videos) {
          for (let i = 0; i < videos.length; i++) {
            videoPaths.push({
              source: `/api/files/${videos[i].physicalName}`,
              title: videos[i].name,
              id: videos[i].id,
              preview: videos[i].description ? `/api/files/${videos[i].description}`
                : 'https://pp.userapi.com/c854328/v854328496/a89ed/_Acd1jm2P-c.jpg'
            })
          }
        }
      }
      return videoPaths
    },
    memberModalTitle() {
      if (this.hasRole('classroom-teacher')) {
        return 'Добавление участников'
      }
      return 'Просмотр участников'
    },
    isCurrentClassPage() {
      return this.$route.path.includes('/class/content/class-page/current')
    },
    isClassEventPage() {
      return this.$route.path.includes('class/content/events')
    },
    isWithMembers() {
      return (!this.$route.path.includes('content') || this.$route.path.includes('class'))
        && this.$route.path.includes('events')
        && this.content.contentObject && this.content.contentObject.status === 'опубликовано'
        && (this.hasRole('classroom-teacher') || this.hasRole('curator'))
    },
    isClassOpenedByTeacher() {
      if (this.$route.params.gpClass === 'current'
          && this.hasRole('classroom-teacher')
      ) {
        return true
      }
      return false
    },
    isLikable() {
      return this.content.contentObject.type === 'Мероприятие'
    },
    isLiked() {
      if (this.content.contentObject && this.content.contentObject.type === 'Мероприятие') {
        return this.content.contentObject.userLike === true
      }
      return false
    },
    isDisliked() {
      if (this.content.contentObject && this.content.contentObject.type === 'Мероприятие') {
        return this.content.contentObject.userLike === false
      }
      return false
    }
  },
  methods: {
    ...mapMutations({
      setContentData: 'content/setContentData',
      updateRating: 'content/updateRating'
    }),
    ...mapActions({
      addContent: 'content/addContent',
      addContentByTeacher: 'content/addContentByTeacher'
    }),
    addEvent() {
      // добавляем контент, после - редирект на только что созданное мероприятие
      this.addContentByTeacher('Мероприятие').then((res) => {
        this.$router.push(`/class/content/events/${res.contentObject.id}`)
      })
    },
    checkPath(p) {
      if (_.isArray(p)) {
        return p.some((path) => this.$route.path.includes(path))
      }
      return this.$route.path.includes(p)
    },
    closeEventMembersModal() {
      this.$bvModal.hide('membersModal')
    },
    isImageHorizontal(photo) {
      const img = new Image()
      img.src = photo
      return img.naturalWidth > img.naturalHeight
    },
    checkPhotoSize(wind) {
      if (this.photoForOpen) {
        const img = new Image()
        img.src = this.photoForOpen
        const widthBefore = img.naturalWidth
        const height = img.naturalHeight
        this.imageWidth = widthBefore
        if (
          wind.clientWidth * 0.8 < widthBefore
            || this.imageWidth > 1130 || wind.clientWidth < 976
        ) {
          this.imageWidth = '100%'
        }
        if (height && height > wind.clientHeight * 0.85 - 130) {
          const proportions = widthBefore / height
          const newWidth = proportions * (wind.clientHeight * 0.85 - 140)
          if ((this.imageWidth !== '100%' && newWidth < this.imageWidth)
              || (wind.clientWidth > 1178 && newWidth < 1106)
              || (wind.clientWidth > 975 && newWidth < 776)
              || (wind.clientWidth > 460 && newWidth < 466)) {
            this.imageWidth = newWidth
          }
        }
      }
    },
    async showPhotoModal(photo) {
      if (photo.source) {
        this.photoForOpen = photo.source
        await this.checkPhotoSize(document.documentElement)
        this.photoForOpenObject = photo
        await this.$refs.photoModal.show()
      }
    },
    gotoPhoto(delta) {
      const index = this.carouselPhotos.indexOf(this.photoForOpenObject)
      let newIndex = (index + delta) % this.carouselPhotos.length
      if (newIndex < 0) {
        newIndex += this.carouselPhotos.length
      }
      this.showPhotoModal(this.carouselPhotos[newIndex])
    },
    showVideoModal(video) {
      this.videoForOpen = video
      // eslint-disable-next-line no-restricted-globals
      this.iframeHeight = screen.height * 0.7
      this.$refs.videoModal.show()
    },
    backToContentList() {
      this.$cookies.set('activeContentButtons', true, '5h')
    },
    onCheckRouteType() {
      const notExistPath = '/page_not_exist'
      if (
        (this.$route.path.includes('event')
          && this.content.contentObject.type !== 'Мероприятие')
        || (this.$route.path.includes('news/')
          && this.content.contentObject.type !== 'Новость')
        || (!this.$route.path.includes('class/content/events') && this.$route.path.includes('class')
          && this.content.contentObject.type !== 'ГП-класс')
        || (this.$route.path.includes('univer')
          && this.content.contentObject.type !== 'ВУЗ-партнер'
          && this.content.contentObject.type !== 'СПО')
        || (this.$route.path.includes('class/content/events') && !this.hasRole('curator')
          && this.currUser.organizationId !== this.content.contentObject.associatedOrgId)
      ) {
        this.$router.push('.', () => {
          this.$router.push(notExistPath)
        })
      }
      this.imgClass()
    },
    imgClass(avatar) {
      if (this.avatarClass !== 'imgVCWrapper') {
        const img = new Image()
        if (avatar) {
          img.src = avatar
          img.onload = () => {
            if (img.width / img.height < 4 / 3 - 0.2) {
              this.avatarClass = 'imgVCWrapper'
            } else {
              this.avatarClass = ''
            }
          }
          img.onerror = () => {
            this.avatarClass = ''
          }
        } else {
          this.avatarClass = ''
        }
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    async onLike() {
      await ContentAPI.updateContentRating(
        this.content.contentObject.id,
        this.isLiked ? null : true,
      )
      this.updateRating('like')
    },
    async onDislike() {
      await ContentAPI.updateContentRating(
        this.content.contentObject.id,
        this.isDisliked ? null : false,
      )
      this.updateRating('dislike')
    },
    replaceYoutubeOembed() {
      const regex = /v=(.*)&/
      const width = document.querySelector('.lead.text-justify').offsetWidth
      if (width) {
        this.contentWidth = width
      }
      document.querySelectorAll('oembed[url]').forEach((element) => {
        const div = document.createElement('div')
        // eslint-disable-next-line no-unneeded-ternary
        div.setAttribute('style', `width: 100%; height: ${((width ? width : this.contentWidth) * 9) / 16}px;`)
        div.innerHTML = `<div style="position: relative; width: 100%; height: 100%;">
                          <iframe src="https://www.youtube.com/embed/${element.attributes.url.value.match(regex)[1]}"
                              style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
                              frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                          </iframe>
                      </div>`
        element.replaceWith(div)
      })
    }
  }
}
</script>

<style lang="scss">
.rating {
  width: 110px;

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      cursor: pointer;
      stroke-width: 0;
    }

    .icon-pressed {
      stroke-width: 16;
    }

    .num {
      font-weight: 500;
    }

    &-like .icon {
      color: #0078c1;
      stroke: #0078c1;
    }

    &-like .icon:hover {
      color: darken(#0078c1, 10%)
    }

    &-dislike .icon {
      color: #d9534f;
      stroke: #d9534f;
    }

    &-dislike .icon:hover {
      color: darken(#d9534f, 10%);
    }
  }
}

.carousel-container {
  height: 300px;
}

.carouselPhoto:hover {
  box-shadow: 0 0 10px 0 rgba(1,122,195,0.6),
    0 0 6px 0 rgba(1,122,195,0.8), 0 0 10px 0 rgba(1,122,195,0.6);
  border: 2px solid #017ac3;
}

.photo-carousel-container {
  position: relative;
  height: 520px;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@media screen and (max-width: 540px) {
  .photo-carousel-container {
    height: 240px;
  }
}
</style>
